import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiDatabase } from 'react-icons/fi';
import MetadataTypeNav from '../components/metadata/MetadataTypeNav';
import MetadataEntriesPanel from '../components/metadata/MetadataEntriesPanel';
import CurrencyMetadataPanel from '../components/metadata/CurrencyMetadataPanel';
import {
  DEFAULT_METADATA_TYPE_ID,
  getEnabledMetadataTypes,
  getMetadataType,
} from '../config/metadataTypes';
import './Metadata.css';

const Metadata = () => {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const enabledTypes = getEnabledMetadataTypes();

  const requestedTypeId = searchParams.get('type') || DEFAULT_METADATA_TYPE_ID;
  const activeType = getMetadataType(requestedTypeId) || getMetadataType(DEFAULT_METADATA_TYPE_ID);
  const activeTypeId = activeType?.id || DEFAULT_METADATA_TYPE_ID;

  const handleTypeSelect = (typeId) => {
    if (typeId === DEFAULT_METADATA_TYPE_ID) {
      searchParams.delete('type');
      setSearchParams(searchParams, { replace: true });
      return;
    }
    setSearchParams({ type: typeId }, { replace: true });
  };

  if (user?.role !== 'admin') {
    return (
      <div className="metadata-page list-page">
        <div className="page-header">
          <div className="metadata-page-header-text">
            <h1>
              <FiDatabase /> Metadata
            </h1>
          </div>
        </div>
        <div className="access-denied">
          <p>You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="metadata-page list-page">
      <div className="page-header">
        <div className="metadata-page-header-text">
          <h1>
            <FiDatabase /> Metadata
          </h1>
          <p className="metadata-page-subtitle">
            Manage lookup values used across the app. Each category can contain many rows.
          </p>
        </div>
      </div>

      <div className="metadata-layout">
        <MetadataTypeNav
          types={enabledTypes}
          activeTypeId={activeTypeId}
          onSelect={handleTypeSelect}
        />

        <div className="metadata-main">
          {!activeType ? (
            <div className="empty-state">
              <p>Select a metadata category to manage its entries.</p>
            </div>
          ) : activeType.panel === 'currencies' ? (
            <CurrencyMetadataPanel key={activeType.id} type={activeType} />
          ) : (
            <MetadataEntriesPanel key={activeType.id} type={activeType} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Metadata;
